import { getConfig } from '@qapline/config';

import { baseApiService } from '../../core';
import { TLoginSchema } from '../schemas';
import { TLoginResponseBody, TRefreshTokenResponseBody } from '../types';

// Endpoints must be resolved at call time to respect runtime mode.

export const authApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        loginUser: builder.mutation<TLoginResponseBody, TLoginSchema>({
            query(data) {
                return {
                    url: getConfig().api.endpoints.auth.login,
                    method: 'POST',
                    body: data,
                };
            },
        }),
        refreshToken: builder.query<TRefreshTokenResponseBody, void>({
            query() {
                return {
                    url: getConfig().api.endpoints.auth.refresh,
                    method: 'POST',
                };
            },
        }),
        logoutUser: builder.query<void, void>({
            query() {
                return {
                    url: getConfig().api.endpoints.auth.logout,
                    method: 'POST',
                };
            },
        }),
        requestResetPassword: builder.mutation<void, { email: string }>({
            query(data) {
                return {
                    url: getConfig().api.endpoints.auth.requestResetPassword,
                    method: 'POST',
                    body: data,
                };
            },
        }),
        verifyResetToken: builder.query<void, { token: string }>({
            query({ token }) {
                return {
                    url: getConfig().api.endpoints.auth.verifyResetToken,
                    method: 'GET',
                    params: { token },
                };
            },
        }),
        resetPassword: builder.mutation<void, { token: string; password: string }>({
            query(data) {
                return {
                    url: getConfig().api.endpoints.auth.resetPassword,
                    method: 'POST',
                    body: data,
                };
            },
        }),
    }),
});

export const {
    useLoginUserMutation,
    useLazyRefreshTokenQuery,
    useRefreshTokenQuery,
    useLazyLogoutUserQuery,
    useRequestResetPasswordMutation,
    useVerifyResetTokenQuery,
    useResetPasswordMutation,
} = authApi;
